(function () {
  var HERO_HANDLE = 'tatpub-hosting-system-edition-01';
  var COMPLETE_SYSTEM_PATH = '/products/' + HERO_HANDLE + '#complete-hosting-system';
  var CSS_HREF = '/cdn/shop/t/2/assets/tatpub-hosting-system.css';

  var SCENE_INTROS = {
    'wobbling-balance-bottle-opener': {
      title: 'Made for Match Night',
      body:
        'A small service object for chilled bottles, quick refills, and the moments when everyone stays close to the screen. Pair it with the TATPUB Hosting System to keep the room moving without sending the host back to the kitchen.'
    },
    'anna-g': {
      title: 'Made for Private Pours',
      body:
        'Wine night begins with the first gesture: opening the bottle. Anna G. brings design, humor, and ceremony to the TATPUB private evening setup.'
    },
    'tatpub-brass-incense-burner': {
      title: 'Made for Private Evening Rituals',
      body:
        'Before the first pour, set the room. The TATPUB Brass Incense Burner adds scent, stillness, and quiet luxury to private evenings around the Hosting System.'
    }
  };

  var SCENE_CTAS = {
    'Match Night': {
      body: 'Complete the match-night setup with hosting cards, marble coasters, a bottle opener, and a hammered brass ice bucket.',
      cta: 'Add Match Night Essential'
    },
    'Private Evening': {
      body: 'Complete the private pour with Carrara coasters, a teak serving tray, Anna G., and the private ritual upgrade.',
      cta: 'Build the Private Evening Setup'
    },
    'Social Gathering': {
      body: 'Build a self-serve hosting point with the teak tray, brass ice bucket, hosting cards, and opening tools.',
      cta: 'Add Hosting Tools'
    }
  };

  function cleanupTatpubFooters() {
    document.querySelectorAll('#tatpub-footer-wrap').forEach(function (footer) {
      footer.remove();
    });
    document.querySelectorAll('.tatpub-home > .tatpub-footer:not(#tatpub-footer)').forEach(function (footer) {
      footer.remove();
    });
    document.querySelectorAll('.shopify-section-group-header-group [data-tatpub-global-footer], .shopify-section-group-header-group .tatpub-footer').forEach(function (footer) {
      footer.remove();
    });
    document.querySelectorAll('[data-tatpub-global-footer]').forEach(function (footer) {
      if (!footer.closest('.shopify-section-group-footer-group')) {
        footer.remove();
      }
    });
  }

  function repairSupportEmailCopy() {
    var replacement =
      'To share room photos, email them to <a href="mailto:support@tatpub.com?subject=Room%20Fit%20Review%20Request%20-%20TATPUB">support@tatpub.com</a> after submitting the consultation request with the subject "Room Fit Review".';

    document.querySelectorAll('p, li, div').forEach(function (node) {
      if (node.children.length > 2) return;
      if (node.textContent.indexOf('OWNER_INPUT_REQUIRED: branded support email needed') !== -1) {
        node.innerHTML = replacement;
      }
    });
  }

  function injectClientCareSupportLines() {
    if (document.querySelector('[data-tatpub-support-line]')) return;

    if (getProductHandle() === HERO_HANDLE) {
      var productInfo = document.querySelector('.product__info-container') || document.querySelector('product-info');
      if (!productInfo) return;
      var line = document.createElement('p');
      line.className = 'tatpub-client-care-support-line';
      line.setAttribute('data-tatpub-support-line', '');
      line.innerHTML =
        'Questions about delivery, room fit, or materials? Contact Client Care at <a href="mailto:support@tatpub.com?subject=Product%20Question%20-%20TATPUB%20Hosting%20System">support@tatpub.com</a>.';
      productInfo.appendChild(line);
    }

    if (window.location.pathname === '/cart') {
      var cartFooter = document.querySelector('.cart__footer') || document.querySelector('main');
      if (!cartFooter) return;
      var cartLine = document.createElement('p');
      cartLine.className = 'tatpub-client-care-support-line';
      cartLine.setAttribute('data-tatpub-support-line', '');
      cartLine.innerHTML =
        'Questions before checkout? Contact Client Care at <a href="mailto:support@tatpub.com?subject=Checkout%20Question%20-%20TATPUB">support@tatpub.com</a>.';
      cartFooter.appendChild(cartLine);
    }
  }

  function ensurePhaseStyles() {
    if (document.querySelector('link[href*="tatpub-hosting-system.css"]')) return;
    var link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = CSS_HREF;
    document.head.appendChild(link);
  }

  function getProductHandle() {
    var match = window.location.pathname.match(/^\/products\/([^/?#]+)/);
    return match ? match[1] : '';
  }

  function injectHeroCompleteSystem() {
    if (getProductHandle() !== HERO_HANDLE || document.getElementById('complete-hosting-system')) return;

    ensurePhaseStyles();
    fetch(window.location.pathname + '?section_id=complete-hosting-system', {
      credentials: 'same-origin',
      headers: { Accept: 'text/html' }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Section request failed');
        return response.text();
      })
      .then(function (html) {
        if (document.getElementById('complete-hosting-system')) return;
        var wrapper = document.createElement('div');
        wrapper.innerHTML = html;
        var section = wrapper.querySelector('#shopify-section-complete-hosting-system') || wrapper.querySelector('[data-tatpub-complete-system]');
        var productInfo = document.querySelector('product-info');
        if (section && productInfo) {
          productInfo.insertAdjacentElement('afterend', section);
        }
      })
      .catch(function () {});
  }

  function injectSceneIntro() {
    var handle = getProductHandle();
    var intro = SCENE_INTROS[handle];
    if (!intro || document.querySelector('[data-tatpub-scene-intro]')) return;

    ensurePhaseStyles();
    var description = document.querySelector('.product__description');
    var productInfo = document.querySelector('.product__info-container');
    var target = description || productInfo;
    if (!target) return;

    var block = document.createElement('div');
    block.className = 'tatpub-product-scene-intro';
    block.setAttribute('data-tatpub-scene-intro', '');
    block.setAttribute('data-product-handle', handle);
    block.innerHTML =
      '<p class="caption-with-letter-spacing">TATPUB Hosting System</p>' +
      '<h2 class="h3">' +
      intro.title +
      '</h2>' +
      '<p>' +
      intro.body +
      '</p>';

    if (description) {
      description.parentNode.insertBefore(block, description);
    } else {
      productInfo.appendChild(block);
    }
  }

  function injectHomepageSceneCtas() {
    if (window.location.pathname !== '/' || document.querySelector('.tatpub-scenario__addon')) return;
    var cards = document.querySelectorAll('.tatpub-scenario');
    if (!cards.length) return;

    ensurePhaseStyles();
    cards.forEach(function (card) {
      var heading = card.querySelector('h3');
      if (!heading) return;
      var data = SCENE_CTAS[heading.textContent.trim()];
      if (!data) return;

      var addon = document.createElement('div');
      addon.className = 'tatpub-scenario__addon';
      addon.innerHTML =
        '<p>' +
        data.body +
        '</p>' +
        '<a class="tatpub-scenario__link" href="' +
        COMPLETE_SYSTEM_PATH +
        '">' +
        data.cta +
        '</a>';
      card.appendChild(addon);
    });
  }

  function runPhaseOneEnhancements() {
    cleanupTatpubFooters();
    repairSupportEmailCopy();
    injectClientCareSupportLines();
    injectHeroCompleteSystem();
    injectSceneIntro();
    injectHomepageSceneCtas();
  }

  runPhaseOneEnhancements();
  document.addEventListener('DOMContentLoaded', runPhaseOneEnhancements);
  window.addEventListener('load', runPhaseOneEnhancements);
  setTimeout(runPhaseOneEnhancements, 100);
  setTimeout(runPhaseOneEnhancements, 600);
  setTimeout(runPhaseOneEnhancements, 1400);
})();
